// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

.monaco-editor .sticky-line {
	color : var(--vscode-editorLineNumber-foreground);
	overflow : hidden;
	white-space : nowrap;
	display : inline-block;
}

.monaco-editor .sticky-line-number {
	text-align : right;
	float : left;
}

.monaco-editor .sticky-line-root {
	background-color : var(--vscode-editorStickyScroll-background);
	overflow : hidden;
	white-space : nowrap;
	width : 100%;
}

.monaco-editor .sticky-line-root:hover {
	background-color: var(--vscode-editorStickyScrollHover-background);
	cursor : pointer;
}

.monaco-editor .sticky-widget {
	width : 100%;
	box-shadow : var(--vscode-scrollbar-shadow) 0 3px 2px -2px;
	z-index : 2;
	background-color : var(--vscode-editorStickyScroll-background);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/monaco-editor-core/esm/vs/editor/contrib/stickyScroll/browser/stickyScroll.css"],"names":[],"mappings":"AAAA;;;+FAG+F;;AAE/F;CACC,iDAAiD;CACjD,iBAAiB;CACjB,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,8DAA8D;CAC9D,iBAAiB;CACjB,oBAAoB;CACpB,YAAY;AACb;;AAEA;CACC,kEAAkE;CAClE,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,0DAA0D;CAC1D,WAAW;CACX,8DAA8D;AAC/D","sourcesContent":["/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n\n.monaco-editor .sticky-line {\n\tcolor : var(--vscode-editorLineNumber-foreground);\n\toverflow : hidden;\n\twhite-space : nowrap;\n\tdisplay : inline-block;\n}\n\n.monaco-editor .sticky-line-number {\n\ttext-align : right;\n\tfloat : left;\n}\n\n.monaco-editor .sticky-line-root {\n\tbackground-color : var(--vscode-editorStickyScroll-background);\n\toverflow : hidden;\n\twhite-space : nowrap;\n\twidth : 100%;\n}\n\n.monaco-editor .sticky-line-root:hover {\n\tbackground-color: var(--vscode-editorStickyScrollHover-background);\n\tcursor : pointer;\n}\n\n.monaco-editor .sticky-widget {\n\twidth : 100%;\n\tbox-shadow : var(--vscode-scrollbar-shadow) 0 3px 2px -2px;\n\tz-index : 2;\n\tbackground-color : var(--vscode-editorStickyScroll-background);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
